module.exports = __webpack_public_path__ + "static/img/GS.8d052796.svg";